import React from 'react';
import PropTypes from "prop-types";
import { Box, Checkbox, FormControlLabel } from "@mui/material";

CheckboxRow.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default function CheckboxRow({ label, checked, onChange }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <FormControlLabel
        control={<Checkbox checked={checked} onChange={onChange} />}
        label={label}
        sx={{ ml: 1 }}
      />
    </Box>
  )
}